require('./bootstrap');

//noty
window.Noty = require('noty');